import { StorageManager } from '_c/business/storage';
import { TChatInputCacheConfig, TRevokeMessageTimestampConfig, TPicCacheConfig } from './typings';
import { GetTopicInfoItem } from '_c/typings/proto';
import { logger } from '_c/util/logger';

let chatInputCacheConfig: TChatInputCacheConfig = {};

if (window.sessionStorage.getItem('chatInputCacheConfig')) {
  chatInputCacheConfig = JSON.parse(window.sessionStorage.getItem('chatInputCacheConfig') as string);
}

let picCacheConfig: TPicCacheConfig = {};
const tempPicCache = window.sessionStorage.getItem('picCacheConfig');
if (tempPicCache) {
  try {
    picCacheConfig = JSON.parse(tempPicCache);
  } catch (e) {
    logger.error('图片缓存不存在或是格式有误', e);
    picCacheConfig = {};
  }
}

const revokeMessageTimestampConfig = StorageManager.getInstance().get('revokeMessageTimestampConfig') ?? {};

const state: TChatStoreState = {
  chatInputCacheConfig,
  picCacheConfig,
  panelCheckedIndex: 0,
  panelListLength: 0,
  channelCheckedIndex: 0,
  channelListLength: 0,
  revokeMessageTimestampConfig: revokeMessageTimestampConfig as TRevokeMessageTimestampConfig,
  topicInfoMap: {},
};

export default state;

export type TChatStoreState = {
  chatInputCacheConfig: TChatInputCacheConfig,
  panelCheckedIndex: number,
  panelListLength: number,
  channelCheckedIndex: number,
  channelListLength: number,
  revokeMessageTimestampConfig: TRevokeMessageTimestampConfig,
  picCacheConfig: TPicCacheConfig,
  topicInfoMap: Record<string, GetTopicInfoItem>;
};
